export default __webpack_public_path__ + "static/media/screen1.369546a3.png";